module.exports = __webpack_public_path__ + "static/media/uploadBlue.0d73da7b.svg";